import type { ReactNode } from 'react';

export const symbol_keyboard_return: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m236-449 145 145q9 9 8.5 21t-9.5 21q-9 9-21.5 9t-21.5-9L141-458q-5-5-7-10t-2-11q0-6 2-11t7-10l197-197q9-9 21.5-9t21.5 9q9 9 9 21.5t-9 21.5L235-508h545v-142q0-13 8.5-21.5T810-680q13 0 21.5 8.5T840-650v141q0 25-17.5 42.5T780-449H236Z"
		/>
	</svg>
);
